module.exports = __webpack_public_path__ + "static/media/manufacturing2.c3859f86.png";